// in src/useCustomTranslate.js
import { useState, useEffect } from 'react';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import es from 'src/languages/ra-language-spanish'
import en from 'src/languages/ra-language-english'
import pt_br from 'src/languages/ra-language-pt-br'

const messages = {
  'es-AR': es,
  'en-US': en,
  'pt-BR': pt_br,
};

const useCustomTranslate = (initialLocale) => {
  const [locale, setLocale] = useState(initialLocale || localStorage.getItem('language') || 'es-AR');
  const [translator, setTranslator] = useState(() => polyglotI18nProvider(() => messages[locale], locale));

  useEffect(() => {
    setTranslator(polyglotI18nProvider(() => messages[locale], locale));
  }, [locale]);

  const translate = (key, options) => {
    return translator.translate(key, options);
  };

  const changeLanguage = (newLocale) => {
    setLocale(newLocale);
  };

  return { translate, changeLanguage, currentLocale: locale };
};

export default useCustomTranslate;
